<template>
    <main-content>
      <pf-terminal-statistics></pf-terminal-statistics>
    </main-content>
</template>

<script>

import PfTerminalStatistics from "@/views/reports/components/Pf-Terminal-Statistics.vue";
import MainContent from "@/components/main-content.vue";

export default {
    components: {
      MainContent,
      PfTerminalStatistics,
    }
}
</script>

<style>

</style>